module.exports = "/build/admin/images/widetile.69cd3e10.png";